import { WeEmulatePeople } from './weEmulatePeople';
import { AboutUs } from './aboutUs';
import { OurPlatform } from './ourPlatform';
import { OurVirtualExperts } from './ourVirtualExperts';
import { Partners } from './partners';

export { WeEmulatePeople, AboutUs, OurPlatform, OurVirtualExperts, Partners };



// WEBPACK FOOTER //
// ./src/components/sections/index.js